import { Select } from 'antd';
import commaNumber from 'comma-number';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import {
  CHART_FIELD_ITEM_SELECTION_METHOD,
  CHART_TYPE,
} from '@/entities/chart/model/constants';
import chartUtils from '@/features/(charts)/chart-renderer/lib/chart-utils';
import { ChartFieldItemSelectionMethodMap } from '@/features/(charts)/chart-renderer/model/chart-maps';

type Props = {
  chartInfo: ChartContextProps;
};

export const ChartCandidateSelector = ({ chartInfo }: Props) => {
  const { state, setState, setSelectedField, selectedField } = chartInfo;
  const candidateCount = chartInfo.tableQuery.data
    ? chartUtils.getSortedRowItems(
        state,
        chartInfo.tableQuery.data,
        state.field.candidates || [],
        true,
      ).tables[0]?.length || 0
    : 0;
  const isTop =
    state.selected_field.method !==
    CHART_FIELD_ITEM_SELECTION_METHOD.USER_DEFINED;

  const onTopChange = (value: CHART_FIELD_ITEM_SELECTION_METHOD) => {
    setState({
      ...state,
      field: {
        ...state.field,
      },
      selected_field: {
        ...state.selected_field,
        method: value,
      },
    });
    setSelectedField({
      method: value,
      items: [],
    });
  };

  const onResetToTopClick = () => {
    setState({
      ...state,
      selected_field: {
        method: CHART_FIELD_ITEM_SELECTION_METHOD.TOP_5,
      },
    });
    setSelectedField({
      method: CHART_FIELD_ITEM_SELECTION_METHOD.TOP_5,
      items: [],
    });
  };

  if (isTop) {
    return (
      <Select
        value={state.selected_field.method}
        options={ChartFieldItemSelectionMethodMap.toArray()}
        style={{ width: 140 }}
        onChange={onTopChange}
        size="small"
      />
    );
  }

  return (
    <Flex a="center" g={4}>
      <Typo>{commaNumber(selectedField.items?.length || 0)}</Typo>
      <Typo>items of</Typo>
      <Typo>{commaNumber(candidateCount)}</Typo>
      {state.type === CHART_TYPE.SINGLE_AXIS && (
        <Button variant="ghost" onClick={onResetToTopClick}>
          Reset to top
        </Button>
      )}
    </Flex>
  );
};
